export * from './badge.module';
export * from './badge.component';
